import styled from 'styled-components';
import { Button } from '@devsbb/ui';
import { Group } from '@/components/Group';

export const Root = styled(Group)<{
  isMobile: boolean;
  isLoading?: boolean;
  bgColor?: string;
}>`
  margin: ${({ isMobile }) => (isMobile ? '-8px 0 16px' : '24px 0 16px')};
  padding: 16px;
  border-radius: 8px;
  background-color: ${({ theme, isLoading, bgColor }) =>
    isLoading ? theme.colors.background.superLightGrey : bgColor};
  overflow-wrap: break-word;
  word-break: break-word;
`;

export const ViewDetailsButton = styled(Button)`
  background-color: ${({ theme }) => theme.colors.background.white};
  color: ${({ theme }) => theme.colors.text.darkerGrey};

  :hover {
    background-color: ${({ theme }) => theme.colors.hover.lighterGrey};
  }
`;
